import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bfa308b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-box" }
const _hoisted_2 = { class: "bar-chart" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "ws_mt12" }

import { ref } from 'vue'
import * as echarts from 'echarts'
import { set, cloneDeep } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'status-pie-chart',
  props: ['data'],
  setup(__props, { expose: __expose }) {

const props = __props

const option = {
  tooltip: {
    show: false,
  },
  series: [
    {
      type: 'pie',
      radius: ['70%', '100%'],
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
      },
      labelLine: {
        show: false,
      },
      data: [],
      color: [],
      hoverAnimation: false,
    },
  ],
}
const chartRef = ref()

const init = () => {
  const { num, otherNum, color } = props.data
  const ops = cloneDeep(option)

  const echartsColor = [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color,
      },
      {
        offset: 1,
        color: '#17C2FA',
      },
    ]),
    'rgba(0,0,0,0)',
  ]

  set(ops, 'series[0].data', [num, otherNum])
  set(ops, 'series[0].color', [color, 'rgba(0,0,0,0)'])

  const myChart = echarts.init(chartRef.value)
  myChart.setOption(ops)
}

__expose({
  init,
})

// onMounted(() => {
//   const myChart = echarts.init(chartRef.value)
//   myChart.setOption(option)
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "chart-conatiner",
        ref_key: "chartRef",
        ref: chartRef
      }, null, 512),
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.data.percent) + "%", 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(props.data.label) + "：" + _toDisplayString(props.data.num) + "台", 1)
  ]))
}
}

})